<!-- routify:options title='Tasks' -->
<!-- routify:options index=1 -->
<!-- routify:options showInNavigation=true -->

<script>
    import { onMount } from 'svelte'
    import { taskStore } from '../../../stores/Task'
    import { fetchJSON } from '../../../common/Backend'
    import TaskList from '../../../components/TaskList.svelte'
    import { t } from 'totalinvoice-frontend-core'
    import { RefreshButton, ServerErrorNotification }  from 'totalinvoice-frontend-core'
    import { STATUS_NONE, STATUS_LOADING, STATUS_SERVER_ERROR } from 'totalinvoice-frontend-core'

    let status = STATUS_LOADING

    let spinSyncButton = true

    let error = ''
    let showServerErrorNotification = false
    $: showServerErrorNotification = status === STATUS_SERVER_ERROR

    onMount(async () => {
        loadData()
    })

    async function loadData() {
        status = STATUS_LOADING
        spinSyncButton = true
        const res = await fetchJSON('task/list')
        if (res.status === 'ok') {
            taskStore.update(s => ({ ...s, tasks: res.data }))
            status = STATUS_NONE

            // Data is loaded too fast to see the spinning icon of the refresh button,
            // so we add a short delay to make sure that the user gets a visible feedback.
            setTimeout(() => spinSyncButton = false, 1000)
        } else {
            error = res
            spinSyncButton = false
            status = STATUS_SERVER_ERROR
        }
    }
</script>

<h2 class="title is-2 is-spaced page-title">{$t('Task List')}</h2>

{#if showServerErrorNotification}
    <ServerErrorNotification bind:active={showServerErrorNotification} {error} />
{/if}

<div class="buttons">
    <RefreshButton refreshing={spinSyncButton} on:click={() => loadData()} />
</div>

<TaskList taskList={$taskStore.tasks} searchable={true} sortable={true} />
